import { motion } from 'framer-motion'
import styled from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H4 } from '@/@bothrs-ui/web/components/typography/Heading'

const StSectionTitle = styled(H4)`
  ${({ theme }) => {
    return `
        display: block;
        background-color: ${theme.Colors.Neutrals.Lighter};
        padding: ${theme.UI.SpacingPx.Space2} ${theme.UI.SpacingPx.Space4};
        margin-bottom: 0;
        border-radius: ${theme.UI.BorderRadius.Small}px;
    `
  }}
`

const StSectionItem = styled.ul``

const StSectionListItem = styled.li`
  display: flex;
  flex-direction: column;
  list-style: none;
  cursor: pointer;

  ${({ theme }) => {
    return `
      padding: ${theme.UI.SpacingPx.Space4} 0;
      gap: ${theme.UI.SpacingPx.Space2};

        & + li {
            border-top: 1px solid ${theme.Colors.Neutrals.Lighter}
        }
    `
  }};
`

const StSectionListItemTitle = styled(Span).attrs({ type: 'BodyMediumBold' })`
  display: block;
`

const AnimatedStSectionListItem = motion(StSectionItem)

export { AnimatedStSectionListItem, StSectionItem, StSectionListItem, StSectionListItemTitle, StSectionTitle }
